// @flow

import type { Merchant } from '@tectonics/prs/merchant/types';
import { getMerchantConfig } from '../get-merchant-config';

export function shouldHideReturnToMerchant(merchant: Merchant): boolean {
  const merchantConfig = getMerchantConfig(merchant);

  return !!merchantConfig?.hide_return_to_merchant_on_confirmed_page;
}
